<template>
    <div class="activity-content ">
        <div class="activity-banner">
            <img src="../../assets/images/a-mrcj-banner@2x.png" alt />
            <a href="javascript:;" class="go-back activity-back" @click="e=>this.$router.push('/activity')"></a>
        </div>
        <div class="activity-list">
            <div class="a-list-item">
                <div class="left-item">
                    <img src="../../assets/images/hfcz-icon-1@2x.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>活动时间</h5>
                    <div class="text-item-warp">
                        <div class="text-item">2020年7月1日-2020年12月31日</div>
                    </div>
                </div>
            </div>
            <div class="a-list-item">
                <div class="left-item">
                    <img src="../../assets/images/hfcz-icon-2@2x.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>活动对象</h5>
                    <div class="text-item-warp">
                        <div class="text-item-row">
                            上海农商银行个人信用卡主卡持卡人    
                            <!-- <a
                                href="javascript:;"
                                @click="e=>{this.$test('FIVE-register-1'); this.$listeners.routePusht('/details/tjx')} "
                                class="apply-activity-btn"
                            ></a> -->
                        </div>

                         <!-- @click="e=>$listeners.routePusht('/details/xcb')"  -->
                        <div class="apply-button-wrapper"> 
                             <a href="javascript:;" class="apply-activity-btn" @click="e=>this.$router.push('/credit')" ></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="a-list-item-wrap">
                <div class="a-list-block">
                    <div class="left-item">
                        <img src="../../assets/images/wsd-icon-1@2x.png" class="a-item-icon" alt />
                    </div>
                    <div class="right-item">
                        <h5>活动内容</h5>
                        <div class="text-item-warp">
                            <div class="text-item">
                                <p>活动期间，持卡人可在“上海农商银行信用卡”微信公众号专属活动页面使用200积分赢得更多积分，同一持卡人每日限抽奖一次。</p>
                            </div>
                          
                           
                        </div>
                      
                    </div>

                </div>
                 <img src="../../assets/images/mrcj-table@2x.png" class="jfsc-table" alt="">
     
            </div>

            <div class="a-list-item a-footer-item jfsc-footer-item">
                <div class="rule-details">
                    <h5>活动细则</h5>
                    <div class="rule-text">
                         <p>1、本次活动对象为上海农商银行个人信用卡（除鑫智白金卡、白金商务卡、商务卡、鑫成卡、鑫福农卡、鑫风卡、优享白金鑫卡随鑫专用卡、优享白金鑫卡分期专用卡、鑫驰白金卡车牌分期专用卡、增值服务通个人卡外）的主卡持卡人。</p>
                        <div class="more-text" v-show="isShow">
                          
                           
                            <p>2、本次活动所指的同一持卡人包括但不限于同一银行卡卡号、同一身份证号、同一微信账号、同一手机号、同一手机识别码等满足任一条件或其他可视为同一持卡人的情形。</p>
                            <p>3、持卡人可通过“上海农商银行信用卡”微信公众号，并完成我行有效信用卡绑定后参与活动。</p>
                            <p>4、每次抽奖需消耗持卡人账户内200有效积分，一经抽奖无法取消或重新抽奖。</p>
                            <p>5、奖励积分一个工作日内导入持卡人账户中，积分有效期以系统显示为准。持卡人可以通过“上海农商银行信用卡”微信公众号查询本人账户的有效积分及积分明细。</p>
                            <p>6、每位持卡人单个自然月获得的所有信用卡积分封顶值为持卡人所持信用卡额度的10倍，超出10倍封顶部分无法计入。</p>
                            <p>7、持卡人知晓并同意，上海农商银行有权对持卡人用卡、还款、资信及风险状况进行综合评估。持卡人如有下述任何一种情况，其享受本活动的资格将被取消，包括但不限于当前账户出现欠款逾期、销户、冻结及其他非正常状态；出现所持信用卡过期、被停用、持卡人自行注销信用卡、违反《上海农商银行信用卡章程》及《上海农商银行信用卡（个人卡）领用合约》或本活动细则及相关规定的。</p>
                            <p>8、如发现持卡人参与活动过程中存在任何利用系统漏洞、外挂软件、插件等手段或工具套取活动奖励、损害活动规则、扰乱正常活动秩序等行为的，包括但不限于使用外挂软件获取活动资格、恶意刷单、有偿转赠权益、与商户串通、倒卖活动奖励、冒用他人信息参与活动、进行虚假交易等，上海农商银行有权取消持卡人参加本次活动及获得本活动奖励的资格。同时，上海农商银行保留追究其法律责任的权利。若系统漏洞、故障或其他原因致使系统无法正常运行，导致持卡人获得与本活动规则不符的奖励，上海农商银行保留取消或收回持卡人参与本活动所获的回馈和奖励的权利。</p>
                            <p>9、在法律许可范围内，上海农商银行有权修订本活动条款及细则（包括但不限于参加资格、消费时间及奖励方式等）、暂停或取消本活动、并经相关途径（如上海农商银行官方网站、对账单、短信、“上海农商银行信用卡”微信公众号或各分支网点等）公告后生效。</p>
                            <p>10、其他未尽事宜，仍受《上海农商银行信用卡章程》、《上海农商银行信用卡（个人卡）领用合约》及其他相关文件约束。</p>
                            <p>11、活动详情以上海农商银行最新公布内容为准，或咨询24小时客服热线021-962999。</p>

                        </div>
                    </div>
                    <a
                        href="javascript:;"
                        class="more-rule"
                        @click="changeMoreRule"
                        v-show="!isShow"
                    >展开详情</a>
                    <div class="collect-wrap" v-show="isShow">
                        <div class="collect-btn" @click="changeMoreRule">
                            <i class="collect-icon"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return { isShow: false };
    },
    methods: {
        changeMoreRule() {
            this.isShow = !this.isShow;
            // this.$test("recommend a-detail-2");
        }
    }
};
</script>

<style lang="scss" scoped>
</style>